import { Controller } from 'stimulus';

export default class SelectController extends Controller {
  static targets = [
    'input',
    'value',
    'list',
    'listButton',
    'button',
  ];

  value = null;

  opened = false;

  selected = false;

  locale = 'ru';

  connect() {
    this.listTarget.dataset.controller = 'scrollbar';
    this.inputTarget.addEventListener('click', this.open);
    this.inputTarget.addEventListener('focus', this.onInputFocus);
    this.inputTarget.addEventListener('blur', this.onInputBlur);
    this.inputTarget.addEventListener('blur', this.onInteractiveElementBlur);
    this.inputTarget.addEventListener('input', this.onInput);
    this.inputTarget.addEventListener('change', this.onInputChange);
    this.buttonTarget.addEventListener('click', this.toggle);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keyup', this.onKeyUp);
    this.listButtonTargets.forEach((button) => {
      button.addEventListener('click', this.onListButtonClick);
      button.addEventListener('blur', this.onInteractiveElementBlur);
      this.disableTabFocus(button);
      button.textContent = button.textContent.replace(/\s+/g, ' ').trim();
    });
    this.disableTabFocus(this.buttonTarget);
    this.locale = document.documentElement.getAttribute('lang') || 'ru';

    if (this.valueTarget.value) {
      const button = this.listButtonTargets.find((item) => (
        item.dataset.value === this.valueTarget.value
      ));
      this.onShowValue(button);
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener('click', this.open);
    this.inputTarget.removeEventListener('focus', this.onInputFocus);
    this.inputTarget.removeEventListener('blur', this.onInputBlur);
    this.inputTarget.removeEventListener('blur', this.onInteractiveElementBlur);
    this.inputTarget.removeEventListener('input', this.onInput);
    this.inputTarget.removeEventListener('change', this.onInputChange);
    this.buttonTarget.removeEventListener('click', this.toggle);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keyup', this.onKeyUp);
    this.listButtonTargets.forEach((button) => {
      button.removeEventListener('click', this.onListButtonClick);
      button.removeEventListener('blur', this.onInteractiveElementBlur);
    });
  }

  open = () => {
    this.element.classList.add('opened');
    this.opened = true;
    this.listButtonTargets.forEach(this.enableTabFocus);
  };

  close = () => {
    this.element.classList.remove('opened');
    this.opened = false;
    this.listButtonTargets.forEach(this.disableTabFocus);
  };

  toggle = () => {
    if (this.opened) {
      this.close();
    } else {
      this.open();
    }
  };

  disableTabFocus = (element) => {
    element.setAttribute('tabindex', -1);
  }

  enableTabFocus = (element) => {
    element.removeAttribute('tabindex');
  }

  isElementInside = (targetElement) => {
    let element = targetElement;
    while (element) {
      if (element === this.element) {
        return true;
      }

      element = element.parentElement;
    }

    return false;
  };

  onInteractiveElementBlur = (event) => {
    if (!this.isElementInside(event.relatedTarget)) {
      this.close();
    }
  };

  onDocumentClick = (event) => {
    if (!this.isElementInside(event.target)) {
      this.close();
    }
  };

  onListButtonClick = (event) => {
    this.clearCurrentSelection();
    event.target.classList.add('active');
    const selected = event.target;
    this.onShowValue(selected);
    this.inputTarget.focus();
    this.inputTarget.setSelectionRange(0, 0);
    this.close();
  };

  clearCurrentSelection = () => {
    this.selected = false;
    const currentSelection = this.listTarget.querySelector('.active');
    if (!currentSelection) {
      return;
    }

    this.value = null;
    this.valueTarget.value = '';
    this.inputTarget.value = '';
    currentSelection.classList.remove('active');
  };

  filterItems = (text) => {
    const search = text.toLocaleLowerCase(this.locale);
    let filteredNumber = 0;
    this.listButtonTargets.forEach((button) => {
      if (button.textContent.toLocaleLowerCase(this.locale).includes(search)) {
        button.style.display = '';
      } else {
        button.style.display = 'none';
        filteredNumber++;
      }
    });

    if (filteredNumber === this.listButtonTargets.length) {
      this.element.classList.add('no-variants');
    } else {
      this.element.classList.remove('no-variants')
    }
    // Trigger reflow:
    this.element.offsetWidth;
  };

  onKeyUp = (event) => {
    if (document.activeElement !== this.inputTarget || this.inputTarget.hasAttribute('readonly')) {
      return;
    }

    if (event.code === 'Enter') {
      this.toggle();
    } else if (!this.opened) {
      this.open();
    }

    this.filterItems(this.inputTarget.value);
  };

  onInput = (event) => {
    if (this.selected) {
      const char = this.inputTarget.value[this.inputTarget.selectionStart - 1];
      this.clearCurrentSelection();
      if (event.inputType === 'insertText') {
        this.inputTarget.value = char;
      }
    }
  };

  onInputChange = (event) => {
    if (!event.target.value.length) {
      this.clearCurrentSelection();
    }
  };

  onInputFocus = () => {
    this.element.classList.add('focused');
  };

  onInputBlur = () => {
    this.element.classList.remove('focused');
  };

  onShowValue = (button) => {
    button.classList.add('active');
    this.value = button.dataset.value;
    this.valueTarget.value = this.value;
    this.inputTarget.value = button.textContent;
    this.selected = true;

    this.element.dispatchEvent(new CustomEvent('selected', {
      detail: {
        button,
      },
    }));
  }
}
